import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MenuFunctionalityEnum } from 'src/app/shared/components/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/components/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { GuideGrievanceNotificationService } from 'src/app/shared/services/API/orchestrator-patient/guide-grievance-notification.service';
import { GetListGuideGrievanceNotificationToCardPageRequest } from 'src/app/shared/services/requests/orchestrator-patient/get-list-guide-grievance-notification-to-card-page.request';
import { GrievanceNotificationStatusEnum } from 'src/app/shared/enum/hospital-document/grievance-notification-status.enum';
import { GuideGrievanceNotificationToCardPageStruct } from 'src/app/shared/services/structs/orchestrator-patient/guide-grievance-notification-to-card-page.struct';
import { GrievanceNotificationService } from 'src/app/shared/services/API/hospital-document/grievance-notification.service';
import { ReportModalComponent } from 'src/app/shared/components/report-modal/report-modal.component';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
    selector: 'app-grievance-notification-completed-list',
    templateUrl: './grievance-notification-completed-list.component.html',
    styleUrls: ['./grievance-notification-completed-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GrievanceNotificationCompletedListComponent implements OnInit {

  @Input() menuModuleEnum: MenuModuleEnum;
  @Input() menuFunctionalityEnum: MenuFunctionalityEnum;
  
  constructor(
    private router: Router,
    private alertService: AlertService,
    public dialog: MatDialog,
    private maskService: MaskService,
    private guideGrievanceNotificationService: GuideGrievanceNotificationService,
    private grievanceNotificationService: GrievanceNotificationService,
    private utilService: UtilService,
  ) { }
    
  public grievanceNotificationStatusEnum: typeof GrievanceNotificationStatusEnum = GrievanceNotificationStatusEnum;

  public masks: Masks = this.maskService.getMasks();
  public listGrievanceNotification: GuideGrievanceNotificationToCardPageStruct[] = [];

  public isFirstLoading: boolean = true;
  public reprintLoading: boolean = false;
  public isLoading: boolean;

  public cpfOrCns: string;
  public cpf: string;
  public cns: string;
  public episode: string;
  public generationDate: string;

  public pageIndex: number = 0;
  public pageSize: number = 50;
  public fullListSize: number;

  ngOnInit(): void {
    this.isLoading = true;
    this.search();
  }

  search(){
    this.isLoading = true;

    let request: GetListGuideGrievanceNotificationToCardPageRequest = new GetListGuideGrievanceNotificationToCardPageRequest();
    request.idGrievanceNotificationStatus = this.grievanceNotificationStatusEnum.completa;
    request.patientCpf = this.cpf;
    request.patientCns = this.cns;
    request.idModule = this.menuModuleEnum;
    request.idEpisode = this.episode ? parseInt(this.episode) : null;
    request.datetimeInclusion = this.generationDate ? this.maskService.formatStringToDate(this.generationDate) : null;
    request.page = this.pageIndex;
    this.guideGrievanceNotificationService.getPaginatedGrievanceNotifications(request).subscribe({
      next: (response)=>{
      
        if(response.isError){
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isFirstLoading = false;
          this.isLoading = false;
          return;
        }
        
        this.listGrievanceNotification = response.listGuideGrievanceNotificationToCardPage;
        this.fullListSize = response.fullSize;
        
        this.isFirstLoading = false;
        this.isLoading = false;
      },
      error: (error)=>{
        console.log(error)
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isFirstLoading = false;
        this.isLoading = false;
      }
    });
  }

  reprintReport(idGuideGrievanceNotification: number) {
    this.reprintLoading = true;
    this.grievanceNotificationService.getGuideGrievanceNotificationReport(idGuideGrievanceNotification).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.reprintLoading = false;
          this.isLoading = false;
          return;
        }
        
        if(response.reportPdf64){
          this.dialog.open(ReportModalComponent, {
            data: {
              reportName: response.reportName,
              reportPdf64: response.reportPdf64,
            },
          });
        }

        this.reprintLoading = false;
        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.reprintLoading = false;
        this.isLoading = false;
        return;
      }
    });
  }

  changePage(pageIndex: number) {
    this.pageIndex = pageIndex;
    this.search();
  }

  private timeoutKeySearch: any = null;

  onKeySearchCPF(event: any) {

    clearTimeout(this.timeoutKeySearch);
    var $this = this;

    this.timeoutKeySearch = setTimeout(function () {

      if(!$this.cpfOrCns) {
        $this.cpf = null;
        $this.cns = null;
      }
      else {
        if ($this.cpfOrCns.replace(/[^0-9]/g, '').replace(' ', '').length <= 11) {
          $this.cpf = $this.cpfOrCns.replace(/[^0-9]/g, '').replace(' ', '');
          if (!$this.utilService.validatorCpf($this.cpf)) {
            $this.alertService.show('Erro', "valor inválido", AlertType.error);
            return;
          }
        }
        else {
          $this.cns = $this.cpfOrCns.replace(/[^0-9]/g, '').replace(' ', '');
          if (!$this.utilService.validatorCns($this.cns)) {
            $this.alertService.show('Erro', "valor inválido", AlertType.error);
            return;
          }
          $this.cns = $this.cpfOrCns.replace(/[^0-9]/g, '').replace(' ', '');
        }
      }

      if (event.keyCode != 13){
        $this.pageIndex = 0;
        $this.search();
      }
    }, 1000);
  }

  onKeySearchEpisode(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.pageIndex = 0;
        $this.search();
      }
    }, 1000);
  }
  
  onKeySearchGenerationDate(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {

      if(!$this.generationDate) {
        $this.generationDate = null;
      } else if (!$this.utilService.validatorDate($this.generationDate)) {
        $this.alertService.show('Erro', "valor inválido", AlertType.error);
        return;
      }

      if (event.keyCode != 13) {
        $this.pageIndex = 0;
        $this.search();
      }
    }, 1000);
  }

  goGrievanceNotification(item) {
    if(this.menuModuleEnum == MenuModuleEnum.classification) {
      this.router.navigate(['/classification/grievance-notification', {idGuideGrievanceNotification: item.idGuideGrievanceNotification, idEpisode: item.idEpisode, completPage: true, readOnly: true}]);

    } else if (this.menuModuleEnum == MenuModuleEnum.basic_care){
      this.router.navigate(['/basic-care/grievance-notification', {idGuideGrievanceNotification: item.idGuideGrievanceNotification, idEpisode: item.idEpisode, completPage: true, readOnly: true}]);
    }
  }
}